<template>
  <th :class="thClass" scope="col">
    <v-select
      :label="labelValue"
      :items="items"
      :clearable="clearable"
      placeholder="Sélectionner au moins 1 filtre"
      multiple
      solo
      class="pa-1"
      hide-details
      dense
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-slot:selection="{ index }">
        <v-chip small color="secondary" v-if="index === 0">
          <span class="span-ellipsis">{{ firstSelected.text }}</span>
        </v-chip>
        <span v-if="index === 1" class="text-caption span-ellipsis">
          (+{{ count - 1 }} autres)
        </span>
      </template>
    </v-select>
  </th>
</template>

<script>
import MobileHelper from "@/mixins/MobileHelper";
export default {
  mixins: [MobileHelper],
  props: {
    label: {
      type: String,
      required: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    value() {
      return this.$attrs?.value || [];
    },
    firstSelected() {
      for (var item of this.items) {
        const { value } = item;
        if (this.value.includes(value)) {
          return item;
        }
      }
      return null;
    },
    count() {
      return this.value.length;
    },
    labelValue() {
      if (this.mobile) {
        return this.label;
      }
      return null;
    },
    thClass() {
      if (this.mobile) {
        return "v-data-table__mobile-row";
      }
      return null;
    },
  },
};
</script>

<style scoped>
.span-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
th {
  background: rgba(0, 0, 0, 0.06);
}
</style>
